import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const CheckboxIndeterminate = createSvgIcon(
  <path d="M24 0H0V24H24V0ZM21.6 10.2V13.8H2.4V10.2H21.6Z" />,
  'CheckboxIndeterminate'
);

export { CheckboxIndeterminate };